import React, { useEffect, useState } from "react";
import { Button, Snackbar } from "@mui/material";
import { applyWaitingServiceWorkerUpdate } from "../../pwa/serviceWorkerRegistration";

/**
 * Notifies users when a new service worker is waiting (production only).
 */
export default function PwaUpdateSnackbar() {
  const [waiting, setWaiting] = useState(false);

  useEffect(() => {
    if (!("serviceWorker" in navigator)) return undefined;

    const onControllerChange = () => window.location.reload();

    const checkWaiting = (registration) => {
      if (registration.waiting) setWaiting(true);
    };

    navigator.serviceWorker.ready.then((registration) => {
      checkWaiting(registration);
      registration.addEventListener("updatefound", () => {
        const worker = registration.installing;
        if (!worker) return;
        worker.addEventListener("statechange", () => {
          if (worker.state === "installed" && navigator.serviceWorker.controller) {
            setWaiting(true);
          }
        });
      });
    });

    navigator.serviceWorker.addEventListener("controllerchange", onControllerChange);
    return () => {
      navigator.serviceWorker.removeEventListener("controllerchange", onControllerChange);
    };
  }, []);

  if (process.env.NODE_ENV !== "production") return null;

  return (
    <Snackbar
      open={waiting}
      message="A new version is available."
      anchorOrigin={{ vertical: "top", horizontal: "center" }}
      action={
        <Button
          color="inherit"
          size="small"
          onClick={() => {
            applyWaitingServiceWorkerUpdate();
            setWaiting(false);
          }}
        >
          Refresh
        </Button>
      }
    />
  );
}
